import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import handPhone from "@/assets/hand-phone.png";

import useMapStore from "@/store/mapStore";
import { t } from "i18next";
import { cn } from "@/lib/utils";

function QRCode({ size, className }: { size?: number; className?: string }) {
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  const currentLanguage = useMapStore((state) => state.currentLang);
  const haveRouteDetails = useMapStore((state) => state.haveRouteDetails);
  const haveRoutePreview = useMapStore((state) => state.haveRoutePreview);
  const routeStart = useMapStore((state) => state.routeStart);
  const routeFinish = useMapStore((state) => state.routeFinish);

  useEffect(() => {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const newParams = new URLSearchParams();
    const originalHref = `${url.href}`;

    // Iterate over the search parameters and delete any that contain 'com.broadsign'
    for (const [key, value] of urlParams.entries()) {
      if (!key.includes("com.broadsign")) {
        newParams.append(key, value);
      }
    }

    // Mall url
    // url.href = "https://www.malloftheemirates.com/en/map";

    newParams.set("qrCode", "true");
    newParams.set("language", currentLanguage);

    if (!routeStart && routeFinish.id) {
      newParams.set(
        "remote_id",
        // "destId",
        routeFinish.properties.remote_id
          ? routeFinish.properties.remote_id
          : routeFinish.id,
      );
    }
    if (routeFinish.id && routeStart) {
      newParams.set(
        "remote_id",
        routeFinish.properties.remote_id
          ? routeFinish.properties.remote_id
          : routeFinish.id,
      );
      if (routeStart !== "kiosk" && routeStart.properties) {
        url.href = originalHref;
        //newParams.set("qrCode", "true");
        //newParams.set("language", currentLanguage);
        newParams.set("startFeature", routeStart.properties.id);
      }
    }

    url.search = newParams.toString();
    setQrCodeUrl(url.href);
  }, [
    haveRouteDetails,
    haveRoutePreview,
    routeFinish,
    routeStart,
    currentLanguage,
  ]);

  return (
    <div
      className={cn(
        "mb-10 mt-auto flex items-center justify-center rounded-xl",
        className,
      )}
    >
      <QRCodeSVG
        value={qrCodeUrl}
        className="shrink-0"
        size={size ? size : 96}
        level="H"
      />
      <p className="tracking-[-1px] text-foreground group-data-[dir=ltr]:pl-4 group-data-[dir=rtl]:pr-4">
        {t("scan-qr-code")}
      </p>
      <img src={handPhone} alt={t("scan-qr-code")} className="-mb-3 w-12" />
    </div>
  );
}

export default QRCode;
